import { useLocation } from "react-router-dom";

const useCurrentPath = () => {
  const location = useLocation();
  const pathSegments = location.pathname
    .split("/")
    .filter((segment) => segment !== ""); // Remove empty parts
  return "/" + pathSegments[pathSegments.length - 1]; // Get the last segment
};
export default useCurrentPath;
